import { FC } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { formatToCurrency } from "shared/utils";
import { Badge, BadgeSize, BadgeVariant } from "shared/components/Badge";
import {
  Template,
  VerificationSchema
} from "types/landlord/verificationTemplate";

import { VerificationMenu } from "./VerificationMenu";

interface ScreeningTemplateProps {
  template: Template;
  addTemplate: (template: Template) => void;
  removeTemplateById: (id: string) => void;
  verificationSchemas: VerificationSchema[];
}

export const ScreeningTemplate: FC<ScreeningTemplateProps> = ({
  template,
  addTemplate,
  removeTemplateById,
  verificationSchemas
}) => {
  const navigate = useNavigate();

  const handleTemplateClick = (template: Template) => {
    navigate(`/verification-templates/${template.id}`);
  };

  return (
    <div
      className="animate-appear flex w-full md:min-w-[340px] max-w-[380px] cursor-pointer flex-col rounded-lg border border-alpha-100 bg-white shadow-sm hover:border-alpha-200 hover:shadow-lg"
      onClick={() => {
        handleTemplateClick(template);
      }}
    >
      {/* Head-er */}
      <div className="grow border-b border-alpha-40  p-6 pt-3">
        <div className="flex justify-between pb-3">
          <div className="flex grow items-center gap-2 overflow-hidden">
            <h2 className="overflow-hidden text-ellipsis whitespace-nowrap break-all text-base font-semibold text-content-1000">
              {template.name}
            </h2>
            {template.default && (
              <Badge
                size={BadgeSize.SM}
                className="shrink-0"
                variant={BadgeVariant.BASE}
              >
                Default
              </Badge>
            )}
          </div>
          <VerificationMenu
            verificationSchemas={verificationSchemas}
            verificationTemplate={template}
            addTemplate={addTemplate}
            removeTemplateById={removeTemplateById}
          />
        </div>
        <p className="text-sm text-content-400">{template.description}</p>
      </div>

      {/* FOOT-er */}
      <div className="flex items-center justify-between px-6 py-4">
        <Badge
          className="shrink-0"
          size={BadgeSize.BASE}
          variant={BadgeVariant.PRIMARY}
        >
          {formatToCurrency(template.applicant_fee)} Application fee
        </Badge>
        <p className="text-xs font-medium capitalize text-content-300">
          {moment(template.updated_at).fromNow()}
        </p>
      </div>
    </div>
  );
};
